module.exports = __webpack_public_path__ + "static/media/30.fb0b7d22.jpg";